/*
 * @Author: Json Chen
 * @Date: 2021-07-08 10:42:13
 * @LastEditTime: 2022-06-01 16:43:26
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/index.tsx
 */

import CommonHeader from '@/src/components/CommonHeader';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { Spin } from 'antd';
import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import DestinationAddressLocalisation from './DestinationAddressLocalisation';
import Package from './Package';
import PickupLocations from './PickupLocations';
import ShippingZone from './ShippingZone';
import WarehouseLocations from './WarehouseLocations';
import { breadcrumbData } from './config';
import styles from './style.module.less';

const permissions = () => {
  const canViewAllLogisticsSettingsPage = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLogisticsAllLogisticsSettings,
        operation: EnumOperation.view_all_logistics_settings_page,
      }),
    ],
  });
  return {
    canViewAllLogisticsSettingsPage,
  };
};
const Logistics = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { canViewAllLogisticsSettingsPage } = permissions();
  const history = useHistory();
  const [warehouseList, setWarehouseList] = useState([]);
  const onGoBackClick = () => {
    history.push(`/settings`);
  };
  return (
    <Spin spinning={false}>
      <div className={styles.logisticsContainer}>
        <CommonHeader
          breadcrumbData={breadcrumbData({ getI18n })}
          onGoBackClick={onGoBackClick}
        />
        <div className={styles.commonContainer}>
          {/* Warehouse locations */}
          {canViewAllLogisticsSettingsPage && (
            <div className={styles.container}>
              <div className={styles.header}>
                <div className={styles.title}>
                  {getI18n('storeLogistics.index.warehouselocations')}
                </div>
                <div className={styles.description}>
                  {getI18n(
                    'storeLogistics.index.warehouselocationsdescription',
                  )}
                </div>
              </div>

              <div className={styles.content}>
                <WarehouseLocations
                  warehouseList={warehouseList}
                  setWarehouseList={setWarehouseList}
                />
              </div>
            </div>
          )}

          {/* Shipping Zone */}
          {canViewAllLogisticsSettingsPage && (
            <div className={styles.container}>
              <div className={styles.header}>
                <div className={styles.title}>
                  {getI18n('storeLogistics.index.shippingZone')}
                </div>
                <div className={styles.description}></div>
              </div>
              <div className={styles.content}>
                <ShippingZone />
              </div>
            </div>
          )}

          {/* Pickup locations */}
          {canViewAllLogisticsSettingsPage && (
            <div className={styles.container}>
              <div className={styles.header}>
                <div className={styles.title}>
                  {getI18n(
                    'storeLogistics.index.clickAndCollectPickupLocations',
                  )}
                </div>
                <div className={styles.description}>
                  {getI18n(
                    'storeLogistics.index.clickAndCollectPickupLocationsdescription',
                  )}
                </div>
              </div>

              <div className={styles.content}>
                <PickupLocations />
              </div>
            </div>
          )}
          {/* Packages */}
          {canViewAllLogisticsSettingsPage && (
            <div className={styles.container}>
              <div className={styles.header}>
                <div className={styles.title}>
                  {getI18n('storeLogistics.index.packages')}
                </div>
                <div className={styles.description}>
                  {getI18n('storeLogistics.index.packagesdescription')}
                </div>
              </div>

              <div className={styles.content}>
                <Package />
              </div>
            </div>
          )}
          {/* Destination Address Localisation */}
          {canViewAllLogisticsSettingsPage && (
            <div className={styles.container}>
              <div className={styles.header}>
                <div className={styles.title}>
                  {getI18n(
                    'storeLogistics.index.destinationAddressLocalisation',
                  )}
                </div>
                <div className={styles.description}>
                  {getI18n(
                    'storeLogistics.index.destinationAddressLocalisationdescription',
                  )}
                </div>
              </div>

              <div className={styles.content}>
                <DestinationAddressLocalisation />
              </div>
            </div>
          )}
        </div>
      </div>
    </Spin>
  );
};

export default Logistics;
